module.exports = __webpack_public_path__ + "static/media/ComercialLine.15cc1afa.svg";